import { Box, Typography } from "@mui/material"
import { useCallback, useState } from "react"
import { Schedule } from "../schedule/Schedule"
import { BasicModal } from "~/shared/ui/modals/BasicModal";
import { IScheduleModalProps } from "~/shared/types/types";

export const ScheduleModal = ({ schedule, setSchedule }: IScheduleModalProps) => {
  const [uiState, setUiState] = useState({
    openSchedule: false,
  });

  const toggleModal = useCallback((key: keyof typeof uiState) => {
    setUiState(prev => ({ ...prev, [key]: !prev[key] }));
  }, []);
  return (
    <Box display="flex" flexDirection="column" gap={0.5}>
      <Typography fontWeight={600} variant="subtitle2">Расписание:</Typography>
      <BasicModal
        open={uiState.openSchedule}
        handleOpen={() => toggleModal('openSchedule')}
        handleClose={() => toggleModal('openSchedule')}
        title_button="Расписание">
        <Schedule
          schedule={schedule}
          setSchedule={setSchedule}
          handleCloseSchedule={() => toggleModal('openSchedule')} />
      </BasicModal>
    </Box>
  )
}